import { render, staticRenderFns } from "./modalDesbloqueioExame.vue?vue&type=template&id=426285e6&"
import script from "./modalDesbloqueioExame.vue?vue&type=script&lang=js&"
export * from "./modalDesbloqueioExame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports